export const manufacturerToClass = (manufacturer?: string) =>
  manufacturer
    ? manufacturer
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // replace diacritics
        .toLowerCase()
        .replace(/\s|[!]|\/|-/g, '')
    : ''
